// Mixin providing validation feature
export default {
  name: 'ValidationMixin',

  /**
   * - rules: validation rules applied to the form field, it's used for backwards compatibility.
   * - veeRules: validation rules applied to the form fields, it's to become the primary way of defining new vee-validate rules.
   *   veeRules could also be used with other built-in rules like min, max...etc but would have to be setup to work with veeRules in the configuration first.
   * - existingItems: List of items already created.
   * - item: Item to be validated which do not have to be in the list of existingItems.
   */
  props: {
    rules: Object,
    veeRules: Object,
    existingItems: { type: Array, default: () => [] },
    item: Object,
    required: Boolean,
    name: String,
    label: String
  },
  data () {
    return {
      initialItem: null
    }
  },
  computed: {
    validationRules: function () {
      let _rules = { required: this.required || false }
      _rules = Object.assign(_rules, this.rules, this.rulesMessagesParsed.veeRules)
      return _rules
    },
    validationLabel: function () {
      return this.label ? this.label.replace(/\*$/, '') : this.name
    },
    rulesMessagesParsed () {
      let rulesParsed = {}
      let messagesParsed = {}
      if (this.veeRules) {
        Object.keys(this.veeRules).forEach(key => {
          const rule = this.veeRules[key]
          if (key === 'unique') rulesParsed[key] = { 'excludedValues': this.excludedValues }
          else if (key !== 'required') {
            rulesParsed[key] = rule
          }
          messagesParsed[key] = rule.message
        })
      }
      return { 'veeRules': rulesParsed, 'messages': messagesParsed }
    },
    excludedValues: function () {
      let excluded = []
      let filteredItems = this.existingItems
      if (!this.initialItem) {
        this.initialItem = Object.assign({}, this.item)
      }
      if (this.initialItem) { // filter only when there is an existing item or item is to be edited
        filteredItems = this.existingItems.filter(currentItem => {
          if (currentItem.id) return currentItem.id !== this.initialItem.id
          else if (currentItem._id) return currentItem._id !== this.initialItem._id
          else return currentItem[this.name] !== this.initialItem[this.name]
        })
      }
      filteredItems.forEach(item => {
        if (item[this.name]) {
          excluded.push(item[this.name])
        }
      })
      return excluded
    }
  },

  methods: {
    errorMessage (failedRules, errors, rulesMessages = this.rulesMessagesParsed.messages) {
      const failedRulesExists = failedRules && Object.keys(failedRules).length > 0
      if (failedRulesExists) {
        errors = Object.keys(failedRules).map(key => {
          return rulesMessages[key] ? this.$t(rulesMessages[key]) : failedRules[key]
        })
      }
      return errors
    }
  }
}
